import { createFileRoute } from "@tanstack/react-router";
import { Competences } from "../../app/views/competence/competences";

export const Route = createFileRoute("/competence/competences")({
  component: Competences,
});
